import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcase32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSuitcase32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 5h4a2 2 0 0 1 2 2v2h-8V7a2 2 0 0 1 2-2m-4 4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2h3a4 4 0 0 1 4 4v11a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4zm12 2H10v5.768a2 2 0 0 1 0 3.464V26h12v-5.768a2 2 0 0 1 0-3.464zm2 9.232a2 2 0 0 0 0-3.464V11h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-1zM8 11v5.768a2 2 0 0 0 0 3.464V26H7a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcase32);
